import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'

import { setAttribute } from '../../actions/registration'

class HomeStepTerm extends Component {

  componentDidMount() {
    if (!this.props.startOk) {
      this.props.history.push('/')
    }
  }

  onClickBack() {
    this.props.history.push('/step4')
  }

  onClickTermsAccept(){
    this.persistData()
  }

  persistData() {
    const currentTime = new Date()
    const registration = ['name', 'email', 'telefone', 'cidade', 'selectedActions', 'rg'].reduce(
      (result, key) => ({
        ...result,
        [key]: this.props.registration[key],
      }), {
        timestamp: currentTime,
        unix_time: currentTime.getTime(),
        export: false,
      },
    )
    global.firebase.firestore().collection('doe_seu_tempo')
      .add(registration)
      .then((document) => {
        this.props.setAttribute('id', document.id)
        this.props.history.push('/share')
      })
  }

  render() {
    return (
      <div>
        <div className="modal-header">
          <div className="container">
            <div className="img-voltar">
              <a onClick={this.onClickBack.bind(this)}>
                <img src="images/voltar.png"  alt="Voltar" />
              </a>
            </div>
            <div className="sobre">Termo de compromisso</div>
          </div>
        </div>

          <div className="termocompromisso">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <h3>TERMO DE COMPROMISSO DE SERVIÇO VOLUNTÁRIO</h3>
                  <p> Pelo presente termo de responsabilidade eu assumo o compromisso de prestar as horas de serviços voluntários  selecionadas, na organização que me for indicada, na qualidade de voluntário, estando ciente de que o serviço tem objetivos cívicos e não será remunerado nem gerará vínculo empregatício ou obrigações trabalhistas e previdenciárias de qualquer natureza, podendo este compromisso ser rescindido a qualquer momento por iniciativa de qualquer das partes.</p>
                  <p><b>Lei nº 9.608, de 18 de fevereiro de 1998</b></p>
                  <p>Dispõe sobre o serviço voluntário e dá outras providências</p>
                  <p><b>Art. 1°</b> – Considera-se serviço voluntário, para fins desta Lei, a atividade não remunerada, prestada por pessoa física a entidade pública de qualquer natureza, ou a Instituição privada de fins não lucrativos, que tenha objetivos cívicos, culturais, educacionais, científicos, recreativos ou de assistência social, inclusive mutualidade.</p>
                  <p><b>Parágrafo único.</b> O serviço voluntário não gera vínculo empregatício, nem obrigação de natureza trabalhista, previdenciária ou afim.</p>
                  <p><b>Art. 2°</b> – O serviço voluntário será exercido mediante a celebração de Termo de Adesão entre a entidade, pública ou privada, e o prestador do serviço voluntário, dele devendo constar o objeto e as condições de seu exercício.</p>
                  <p><b>Art. 3°</b> – O prestador de serviço voluntário poderá ser ressarcido pelas despesas que comprovadamente realizar no desempenho das atividades voluntárias.</p>
                  <p><b>Parágrafo único.</b> As despesas a serem ressarcidas deverão estar expressamente autorizadas pela entidade a que for prestado o serviço voluntário.</p>
                  <p><b>Art. 4°</b> – Esta Lei entra em vigor na data de sua publicação.</p>
                  <p><b>Art. 5°</b> – Revogam-se as disposições em contrário.</p>
                  <p>Fernando Henrique Cardoso<br />
                  Brasília, 18 de fevereiro de 1998; 177º da Independência e 110º da República.</p>
                  <p><b>Lei nº 13.297, de 16 de junho de 2016</b></p>
                  <p>O Ato em referência altera o artigo 1º da Lei 9.608, de 18/02/98, para incluir a assistência à pessoa como objetivo de atividade não remunerada reconhecida como serviço voluntário.</p>
                  <p><b>Art. 1º</b> O caput do art. 1º da Lei nº 9.608, de 18 de fevereiro de 1998, passa a vigorar com a seguinte redação:<br />
                  “Art. 1º Considera-se serviço voluntário, para os fins desta Lei, a atividade não remunerada prestada por pessoa física a entidade pública de qualquer natureza ou a instituição privada de fins não lucrativos que tenha objetivos cívicos, culturais, educacionais, científicos, recreativos ou de assistência à pessoa.”</p>
                  <p><b>Art. 2º</b> Esta Lei entra em vigor na data de sua publicação.</p>
                  <p>Michel Temer
                    <br />Alexandre de Moraes
                    <br />Ronaldo Nogueira de Oliveira
                    <br />Brasília, 16 de junho de 2016.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              <div className="col-md-12">
              <a onClick={this.onClickTermsAccept.bind(this)}>
                <button className="bt fecharpedido termobt">Li e aceito o <b>termo de voluntáriado</b></button>
              </a>
              </div>
            </div>
          </div>
      </div>
    )
  }
}

HomeStepTerm.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }),
  registration: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    telefone: PropTypes.string,
    cidade: PropTypes.string,
  }).isRequired,
  setAttribute: PropTypes.func.isRequired,
  startOk: PropTypes.bool.isRequired,
}

HomeStepTerm.defaultProps = {
  history: {
    push: () => { },
  },
}


const mapStateToProps = state => ({
  registration: state.registration,
  startOk: !!state.registration['start-ok'],
})

const mapDispatchToProps = {
  setAttribute,
}

export default connect(mapStateToProps, mapDispatchToProps)(HomeStepTerm)



// WEBPACK FOOTER //
// ./src/components/home/Term.js